import { ModalContentProps, TextProps } from '@chakra-ui/react';
import { UserType } from 'modules/User/user.types';
import { ReactNode } from 'react';
import { Color } from 'types/basic.types';

type UpgradePlan = UserType | null;

export interface CommonGatedUpgradeModalContentProps {
  onClickUpgrade: () => void;
  upgradePlan: UpgradePlan;
  modalImg?: string;
  modalType: ModalUpgradeType;
  modalContentProps?: ModalContentProps;
}

export interface CommonGatedUpgradeModalProps {
  isOpen: boolean;
  onClickUpgrade: () => void;
  onClose: () => void;
  upgradePlan: UpgradePlan;
  modalImg: string;
  modalType: ModalUpgradeType;
  modalContentProps?: ModalContentProps;
}

export type UpgradeButtonProps = CommonGatedUpgradeModalContentProps;
export interface ContentProps extends CommonGatedUpgradeModalContentProps {}

export interface UpgradeDescription {
  modalType: ModalUpgradeType;
}

export type HeaderProps = {
  upgradePlan: UpgradePlan;
  modalType: ModalUpgradeType;
};
export type SubheaderProps = HeaderProps;

export interface DescriptionProps {
  children: ReactNode;
  lineHeight?: string;
  fontWeight?: string;
}

export interface CustomTextProps {
  fontSize: number;
  color: string;
  children: ReactNode;
  as?: TextProps['as'];
}

export interface IconProps {
  color: Color;
}

export interface DescriptionWithIconProps {
  color: Color;
  children: React.ReactNode;
}

export type ModalUpgradeType =
  | 'improve-text'
  | 'map-charts'
  | 'icon-upgrade'
  | 'font-kit'
  | 'brand-kit'
  | 'templates'
  | 'folder'
  | 'background-remover';

export enum ModalUpgradeTypeEnum {
  ImproveText = 'improve-text',
  MapCharts = 'map-charts',
  IconUpgrade = 'icon-upgrade',
  BrandKit = 'brand-kit',
  FontKit = 'font-kit',
  Templates = 'templates',
  Folder = 'folder',
  BackgroundRemover = 'background-remover',
}
